import React from "react";
import { shape, string } from "prop-types";
import _ from "lodash";
import { Field } from "formik";
import { Row, Col } from "react-flexbox-grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";

const DescriptionsArray = props => {
  const { itemKey=null, values=null, label=null, arrayHelpers=null } = props;
  const innerItems = _.get(values, itemKey, []);
  const fields = innerItems ? innerItems.map((description, index) => {
    return (
      <Field name={`${itemKey}.${index}`} key={index}>
        {({ field }) => {
          return (
            <TextField
              id="outlined-multiline-flexible"
              label={`${label} ${index + 1}`}
              multiline
              rowsMax="4"
              margin="normal"
              fullWidth
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Remove item from array"
                      onClick={() => arrayHelpers.remove(index)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              {...field}
            />
          );
        }}
      </Field>
    );
  }) : [];

  return (
    <Row end="xs">
      <Col xs={12}>{fields}</Col>
      <Col xs={12}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => arrayHelpers.push()}
          style={{ marginTop: 15 }}
        >
          Agregar
          <AddIcon />
        </Button>
      </Col>
    </Row>
  );
};

DescriptionsArray.propTypes = {
  itemKey: string.isRequired,
  label: string.isRequired,
  values: shape({}).isRequired,
  arrayHelpers: shape({}).isRequired
};

export default DescriptionsArray;



// WEBPACK FOOTER //
// ./src/components/descriptions/index.js